import React from "react";
import ReactQuill from "react-quill";
import { Controller, useFormContext } from "react-hook-form";

const Description = ({ isPremium, setPremiumChangesMade }) => {
  // Use the form context provided by FormProvider in App
  const { control, watch } = useFormContext();

  // Watch the value to display the preview
  const description = watch("premium.company_description");

  return (
    <div className="provider-section">
      <h3>Company Description</h3>

      {/* Register React Quill using Controller */}
      <Controller
        name="premium.company_description"
        control={control}
        render={({ field }) => (
          <ReactQuill
            value={field.value}
            onChange={val => {
              // 1) Inform RHF that the field has changed:
              field.onChange(val);

              // 2) Then set "premium changes" to true
              setPremiumChangesMade(true);
            }}
          />
        )}
      />

      <div className="mt-4">
        <h4>Preview:</h4>
        {/* Display the preview. Using dangerouslySetInnerHTML if you want to render HTML */}
        <div className="border p-4" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

export default Description;
